import { fExecuteAPI } from "../../Server/Apis";
import {
  inv05_SalesOrder_Attributes_GETROW,
  inv05_SalesOrder_QuotationSearch_GETROW, 
  RpDesign_getGitterColumns_trnTyp_GETROW,
} from "../../Server/ApiV2";
import { fAlertToast, Get_TransItemStockUOM } from "../../Utility/Utilitys";
import { Set_SalesOrder_HeadObject_PayMode } from "./SliceSalesOrder";
import { vRdxUserInfo, SalesOrderRo } from "../../Redux/roStore";
import moment from "moment";
export const sItemSearchData = [
  "Any",
  "Code",
  "Barcode",
  "Name",
  "RefNo",
  "NameFL",
];
export const sTrnTyp = "INV06";
export const sCustomerSearchData = ["Any", "Code", "Name"];

export const GCVanMaster_SalesGroup_GridData_Columns = [
  { field: "id", headerName: "id", hide: true },
  { field: "UId", headerName: "Code" },
  { field: "Srno", headerName: "SrNo", width: 90 },
  { field: "EMPID", headerName: "Employee ID", width: 120 },
  { field: "EMPNAME", headerName: "Employee Name", width: 350 },
  { field: "Typ", headerName: "Type", width: 100 },
  { field: "Active", headerName: "Active", width: 100 },
];
export const GCEmployee_SalesGroup_GridData_Columns = [
  { field: "id", headerName: "id", hide: true },
  { field: "SrNo", headerName: "SrNo", width: 50 },
  { field: "EMPID", headerName: "Employee ID", width: 120 },
  { field: "SName", headerName: "Name", width: 300 },
  { field: "FName", headerName: "First Name", width: 150, hide: true },
  { field: "LName", headerName: "Last Name", width: 180, hide: true },
  { field: "MName", headerName: "Middle Name", width: 100, hide: true },
  { field: "InActive", headerName: "InActive", width: 60 },
  { field: "JOBTITLE", headerName: "Job Title", width: 80 },
  { field: "Gender", headerName: "Gender", width: 60 },
  { field: "DOB", headerName: "DOB", width: 100 },
  { field: "Country", headerName: "Country", width: 120 },
  { field: "Maritial", headerName: "Maritial", width: 60 },
  { field: "Mobile", headerName: "Mobile", width: 120 },
  { field: "Dept", headerName: "Dept", width: 50 },
  { field: "Br", headerName: "Br", width: 50 },
  { field: "Loc", headerName: "Loc", width: 50 },
  { field: "EmployementDt", headerName: "EmployementDt", width: 180 },
  { field: "DOJ", headerName: "DOJ", width: 190 },
  { field: "Phone", headerName: "Phone", width: 90 },
  { field: "EMail", headerName: "EMail", width: 150 },
  { field: "CompEMail", headerName: "CompEMail", width: 90 },
  { field: "CompPhone", headerName: "CompPhone", width: 90 },
  { field: "CompExt", headerName: "CompExt", width: 90 },
  { field: "CompMobile", headerName: "CompMobile", width: 120 },
  { field: "TerminationDt", headerName: "TerminationDt", width: 90 },
];
//ABC
var vheaderArrow = 0;
const fRightClick = (e) => {
  vheaderArrow = vheaderArrow !== 1 ? vheaderArrow + 1 : 1;

  var headerMainTag = document.getElementById(
    "wms-salese-invoice-id"
  ).childNodes;
  for (let index = 0; index < headerMainTag.length; index++) {
    if (vheaderArrow === index) {
      headerMainTag[index].classList.add("main-wms-sales-invoice-show-sm");
    } else {
      headerMainTag[index].classList.remove("main-wms-sales-invoice-show-sm");
    }
  }
};

const fLeftClick = (e) => {
  vheaderArrow = vheaderArrow !== 0 ? vheaderArrow - 1 : 0;
  var headerMainTag = document.getElementById(
    "wms-salese-invoice-id"
  ).childNodes;
  for (let index = 0; index < headerMainTag.length; index++) {
    if (vheaderArrow === index) {
      headerMainTag[index].classList.add("main-wms-sales-invoice-show-sm");
    } else {
      headerMainTag[index].classList.remove("main-wms-sales-invoice-show-sm");
    }
  }
};

export const GetSearchItem = async (
  xData,
  xType,
  xA_Loc,
  setSearchGridData
) => {
  let vSeatchVendor = {
    Data: xData,
    Type: xType,
    Loc: xA_Loc,
  };
  const vItemSearch = await fExecuteAPI("SEARCHITEM001_GETROW", vSeatchVendor);
  if (vItemSearch.Type === "SUCCESS") {
    let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setSearchGridData(vItemSearchArr);
  } else {
    fAlertToast(
      "FAILED",
      vItemSearch.response.data.message
        ? vItemSearch.response.data.message
        : "Error in DocLoading"
    );
  }
};
export const GetQuotationSearch = async (
  xData,
  xType,
  xA_Loc,
  setQuotationSearchGridData
) => {
  let vSeatchVendor = {
    v_Data: xData,
    v_Type: xType,
    v_Loc: xA_Loc,
  };
  const QuotationSearch = await inv05_SalesOrder_QuotationSearch_GETROW(
    vSeatchVendor
  );
  if (QuotationSearch?.status === 200) {
    let QuotationSearchArr = QuotationSearch?.data?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setQuotationSearchGridData(QuotationSearchArr);
  }
};

export const GetSearchCustomer = async (
  xData,
  xType,
  xA_Loc,
  setCustSearchGridData
) => {
  let vSeatchVendor = {
    Data: xData,
    Type: xType,
    Loc: xA_Loc,
  };
  const vItemSearch = await fExecuteAPI("PARTYSEARCH001_GETROW", vSeatchVendor);
  if (vItemSearch.Type === "SUCCESS") {
    let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setCustSearchGridData(vItemSearchArr);
  } else {
    fAlertToast(
      "FAILED",
      vItemSearch.response.data.message
        ? vItemSearch.response.data.message
        : "Error in DocLoading"
    );
  }
};

const fDefaultPayload = (xPaymode, dispatch, setPaymodeEnable) => {
  let iPaymode = xPaymode === "BOTH" ? "CREDIT" : xPaymode;
  //client req
  if (xPaymode === "BOTH") {
    setPaymodeEnable(false);
  } else {
    setPaymodeEnable(true);
  }

  dispatch(
    Set_SalesOrder_HeadObject_PayMode({
      A_PayMode: iPaymode,
    })
  );
  return iPaymode;
};
//API GET_BATCH_DETAILS_GETROW_001
const Get_GCSearchBtn = async (xData, xType, xExact = "N") => {
  const vRdxUserInfoObj = vRdxUserInfo();
  let vLoaded_Cost_FreightObj = {
    v_Data: xData,
    v_Type: xType,
    v_TrnTyp: sTrnTyp,
    v_UserId: vRdxUserInfoObj.UserID,
    Exact: xExact,
  };
  const vLandedCostDropdownSearch = await fExecuteAPI(
    "Common_transpartylist_GETROW",
    vLoaded_Cost_FreightObj
  );
  if (vLandedCostDropdownSearch.Type?.toUpperCase() === "SUCCESS") {
    let GridID = [];
    if (vLandedCostDropdownSearch.ResultSet.length > 0) {
      let GridID = vLandedCostDropdownSearch.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      return GridID;
    } else {
      return GridID;
    }
  } else {
    fAlertToast("FAILED", "Error in loading LandedCost Api");
    return [];
  }
};

const GetOSAmount = async (xLoc, xParty, setOsAmount) => {
  const { HeadObject } = SalesOrderRo();
  let vOsAmtObj = {
    Loc: xLoc,
    Party: xParty,
  };
  if (HeadObject.A_DocStat === "ENTER") {
    const vOsAmt = await fExecuteAPI("Common_partyosamtt_GETROW", vOsAmtObj);
    if (
      vOsAmt?.Type?.toUpperCase() === "SUCCESS" &&
      vOsAmt?.ResultSet?.length > 0
    ) {
      setOsAmount((obj) => ({
        ...obj,
        NetOsAmt: vOsAmt.ResultSet[0].NetAmtWithoutPDC,
        PDCAmt: vOsAmt.ResultSet[0].PDCAmt,
        BalanceOsAmt: vOsAmt.ResultSet[0].NetAmtAfterPDC,
      }));
    } else {
      fAlertToast(
        "FAILED",
        vOsAmt.response.data.message || vOsAmt.response.data.Status
      );
    }
  } else {
    setOsAmount((obj) => ({
      ...obj,
      NetOsAmt: 0,
      PDCAmt: 0,
      BalanceOsAmt: 0,
    }));
  }
};

export const GetAttributes = async (
  setObjectRights,
  setUser_Doc_Arr,
  setDocLoading,
  setCurrency,
  setSalesman,
  setTaxType,
  setLocation,
  setAuditSelectArr,
  setSupervisorSlabs,
  setOtherSlabs
) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  var vObj = {
    userCode: vRdxUserInfoObj.UserID,
    userGroupCode: vRdxUserInfoObj.UserGroupCode,
  };
  const iAttributes = await inv05_SalesOrder_Attributes_GETROW(vObj);
  if (iAttributes?.status === 200) {
    setUser_Doc_Arr(iAttributes?.data?.ResultSet?.UserDoc);
    setObjectRights(iAttributes?.data?.ResultSet?.Rights);
    setDocLoading(iAttributes?.data?.ResultSet?.DocLoading);
    setCurrency(iAttributes?.data?.ResultSet?.Currency);
    setSalesman(iAttributes?.data?.ResultSet?.Salesman);
    setTaxType(iAttributes?.data?.ResultSet?.TaxType);
    setLocation(iAttributes?.data?.ResultSet?.Loc);
    setAuditSelectArr(iAttributes?.data?.ResultSet?.AuduitFields);
    setSupervisorSlabs(iAttributes?.data?.ResultSet?.SupervisorSlabs);
    setOtherSlabs(iAttributes?.data?.ResultSet?.OtherSlabs);
    return iAttributes?.data?.ResultSet;
  } else {
    return [];
  }
};
export const getTransItemStockUOM = async (
  setTransItemStockObj,
  xB_Itmcd,
  xB_Unit,
  xLoc
) => {
  let ApiObj = await Get_TransItemStockUOM(xB_Itmcd, xB_Unit, xLoc);
  if (ApiObj?.length > 0) {
    setTransItemStockObj({
      RPStock: ApiObj[0]?.RPStock,
      MSP: ApiObj[0].MSP,
      CostPr: ApiObj[0].CostPr,
      LPRate: ApiObj[0].LPRate,
    });
  }
};
export {
  GetOSAmount,
  fRightClick,
  fLeftClick,
  fDefaultPayload,
  Get_GCSearchBtn,
};
